import { createPinia } from 'pinia'
import StorePluginPersist from 'pinia-plugin-persist'

const pinia = createPinia()
pinia.use(StorePluginPersist)

export default pinia